import TileLayer from '@arcgis/core/layers/TileLayer';
import { Observable } from 'rxjs';

import { FsAlarmAdvancedMarker } from '@lib/alarms';
import { SnAlarm, SnCamera } from '@lib/api/entities';
import { IFsMap } from '@lib/geo/core';
import { GoogleMapLayer, GoogleMapPopup } from '@lib/geo/google/map';
import { FsMapPopup } from '@lib/geo/map';
import { MapCamerasFacadeService } from '@lib/geo/map';

export abstract class FsMapAlarmsServiceProvider<TMap extends IFsMap> {
  abstract get geospatialProvider(): string;
  abstract get id(): string;

  // Map-specific properties only
  abstract get mapLayer(): GoogleMapLayer | TileLayer;
  abstract get map(): IFsMap;
  abstract get selectedPopup(): GoogleMapPopup | FsMapPopup<TMap>;

  // Properties required for facade compatibility
  abstract get selectedAlarm$(): Observable<{
    alarm: SnAlarm;
    cameras: SnCamera[];
    action?: string;
  }>;
  abstract get isAvailable(): boolean;
  abstract get viewAlarmDetails$(): Observable<SnAlarm>;
  abstract get alarmAdvancedMarker(): FsAlarmAdvancedMarker[];
  abstract get alarmClusterAdvancedMarkers(): FsAlarmAdvancedMarker[];

  // Map-specific methods only
  abstract onMapLoaded(map: TMap, filteredTypes?: string[], filteredReasons?: string[]): void;
  abstract addToMap(): void;
  abstract removeFromMap(): void;
  abstract setCamerasService(camerasService: MapCamerasFacadeService<TMap> | null): void;
  abstract isSkydioAlarm(alarm: SnAlarm): boolean;
  abstract getCurrentLocationForAlarm(alarm: SnAlarm): [number, number] | null;
  abstract setAlertClustering(enabled: boolean): void;

  // Methods required for facade compatibility
  abstract deselect(): void;
  abstract closeAlarmPopupOnListener(alarm: SnAlarm): void;
}
